import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
  DOCUMENT
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AUTH_TOKEN_KEY, UserService } from './services/user.service';
import { MenuOptionsService } from './services/menuoptions.service';
// import 'grd/grd.css';
import { AppSideNavBarService } from './common/ui/app-side-nav-bar/app-side-nav-bar.service';
import { RouteDataModel } from './models/route-data.model';
import { PageService } from './common/page/page.service';
import { Subscription } from 'rxjs';
import { delay, filter, map, mergeMap, switchMap } from 'rxjs/operators';
import _ from 'lodash';
// import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { SubscriptionService } from './services/subscription.service';
import { ToasterService, ToasterType } from './services/toaster.service';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { UserIdleServiceEnkash } from './user-idle-service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TitleChangerService } from './titleChanger.service';
import { ProductGuideService } from './services/product-guide.service';
import { LocalStorageService } from './services/localStorage.service';
import { LOCAL_STORAGE_KEYS } from './constant';
import { environment } from '../environments/environment';

import { RequestState } from './common/http/RequestState';
import { OtpModalComponent } from './modules/shared/components/otp-modal/otp-modal.component';
import { ConfirmationModalService } from './admin/confirmation-modal.service';
import { UserCompanyModel } from '@app/models/user.model';
import { EnumService } from '@app-module/enum-dropdown/enum-service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  isSwitchCompany: boolean = false;
  @HostListener('window:beforeunload', ['$event'])
  unloadHandler(event: BeforeUnloadEvent) {
    if (this.isSwitchCompany) {
      this.isSwitchCompany = false;
      return;
    }
    if (this.userService.isLogoutOnTabClosed()) {
      event.preventDefault();
      this.userService.logout().subscribe(() => {
        this.userIdleService.setUserLoggedIn(false);
        this.enumService.clearCache();
        this.router.navigate(['']);
        this.userService.currentUser = null;
      });
    }
  }
  @ViewChild('contentDiv', { static: true })
  contentDiv: ElementRef;
  sidebarEnabled = false;
  switchCompanyArray: UserCompanyModel[] = [];
  pushNotificationArray: any[] = [];
  unReadNotificationCount: number = 0;
  switchCompanySelected: UserCompanyModel;
  title = 'app';
  routeData: RouteDataModel = {};

  UserRolesArray = [];
  userRoleSelected: any;

  // boolean flags
  sideNavOpened = false;
  isMobile = false;
  isSideNavHidden = false;
  isHeaderImageHidden = false;
  isSettingButtonHidden = false;

  callingCompanyDetails: boolean = false;

  private subscriptions: Subscription = new Subscription();
  @ViewChild('childModal', { static: false }) childModal: TemplateRef<any>;
  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.keyCode === 27) {
      this.modalRef && this.modalRef.hide();
      this.modalRef = null;
      this.idle.watch();
    }
  }
  modalRef: BsModalRef;
  constructor(
    private idle: Idle,
    private titleChangerService: TitleChangerService,
    private modalService: BsModalService,
    public router: Router,
    private userIdleService: UserIdleServiceEnkash,
    public userService: UserService,
    private menuOptionsService: MenuOptionsService,
    private location: Location,
    public sideNavService: AppSideNavBarService,
    public route: ActivatedRoute,
    protected pageService: PageService,
    // private gtmService: GoogleTagManagerService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private subscriptionService: SubscriptionService,
    private toasterService: ToasterService,
    private productGuideService: ProductGuideService,
    private localStorageService: LocalStorageService,
    private confirmationModal: ConfirmationModalService,
    private enumService: EnumService
  ) {

    idle.setIdle(3600); //60 min
    idle.setTimeout(900); // 15 min
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idle.watch();
    });

    idle.onIdleStart.subscribe(() => {
      if (this.modalRef) {
        return;
      }
      const isLoggedIn = !!localStorage.getItem(AUTH_TOKEN_KEY);
      if (isLoggedIn) {
        this.userService.loadUserInstance();
      }
      if (isLoggedIn && this.userService && this.userService.currentUser && this.userService.currentUser.access_token) {
        this.modalRef = this.modalService.show(this.childModal, { keyboard: false, backdrop: 'static' });
      }
    });

    idle.onTimeout.subscribe(() => {
      const isLoggedIn = !!localStorage.getItem(AUTH_TOKEN_KEY);
      if (isLoggedIn) {
        this.userService.loadUserInstance();
      }
      if (isLoggedIn && this.userService && this.userService.currentUser && this.userService.currentUser.access_token) {
        this.userService.logout().subscribe(() => {
          this.modalRef && this.modalRef.hide();
          this.modalRef = null;
          this.userIdleService.setUserLoggedIn(false);
          this.enumService.clearCache();
          this.router.navigate(['']);
          this.userService.currentUser = null;
        });
      }
    });


    // NOTE:-To be Removed In Future
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.route),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data),
    )
      .subscribe((event) => {
        if (event && event.category && (event.category === 'home' || event.category === 'reward')) {
          return;
        }
        this.titleChangerService.updateTitle('EnKash');
      });


    this.userIdleService.getUserLoggedIn().subscribe(userLoggedIn => {
      if (userLoggedIn) {
        idle.watch();
      } else {
        idle.stop();
      }
    })

    this._renderer2.listen('window', 'click', (e: Event) => {
      if (e.target !== this.childModal.elementRef.nativeElement && this.modalRef) {
        this.modalRef && this.modalRef.hide();
        this.modalRef = null;
        this.idle.watch();
      }
    });

    if (this.userService.loadUserInstance()) {
      this.userService.retrieveSwitchCompany(this.userService.currentUser.userCompanyModel || [])
      this.userService.userRolesAction(this.userService.currentUser.roles || [])
      this.userService.loadUserCompanyInstance();
      this.userService.loadUserutmInstance()
      this.menuOptionsService.initMenuOptions();
    } else if (!this.isPublicPage()) {
      this.router.navigate(['']);
    }

    router.events.pipe(filter((e) => e instanceof NavigationEnd)).forEach(() => {
      this.routeData = this.getRouteDataFromTree();
      this.displayVerificationNotification();
    });

    // router.events.forEach(item => {
    //   if (item instanceof NavigationEnd) {
    //     const gtmTag = {
    //       event: 'page',
    //       pageName: item.url
    //     };
    //     this.gtmService.pushTag(gtmTag);
    //   }
    // });
  }

  hideChildModal(): void {
    this.modalRef.hide();
    this.modalRef = null;
  }

  stay() {
    this.modalRef.hide();
    this.modalRef = null;
    this.idle.watch();
  }

  logout(): void {
    this.userService.logout().subscribe(() => {
      this.modalRef && this.modalRef.hide();
      this.modalRef = null;
      this.userIdleService.setUserLoggedIn(false);
      this.enumService.clearCache();
      this.router.navigate(['']);
      this.userService.currentUser = null;
    });

  }

  displayVerificationNotification() {
    if (this.subscriptionService.getPreloadNotification('preloadSubscription')) {
      if (this.subscriptionService.getPreloadNotification('preloadSubscription') === 'true') {
        this.toasterService.showToaster('Email Verified Successfully!', ToasterType.SUCCESS);
      } else {
        this.toasterService.showToaster('We could not verify your email. Please try again.', ToasterType.ERROR);
      }
      this.subscriptionService.clearPreloadNotification('preloadSubscription');
      this.router.navigate([], {
        queryParams: {
          ev: null,
        },
        queryParamsHandling: 'merge',
      });
    } else if (this.subscriptionService.getPreloadNotification('preloadError')) {
      this.toasterService.showToaster(this.subscriptionService.getPreloadNotification('preloadError'), ToasterType.ERROR);
      this.subscriptionService.clearPreloadNotification('preloadError');
      this.router.navigate([], {
        queryParams: {
          error: null,
          bc: null,
        },
        queryParamsHandling: 'merge',
      });
    } else if (this.subscriptionService.getPreloadNotification('preloadMessage')) {
      this.toasterService.showToaster(this.subscriptionService.getPreloadNotification('preloadMessage'), ToasterType.SUCCESS);
      this.subscriptionService.clearPreloadNotification('preloadMessage');
      this.router.navigate([], {
        queryParams: {
          message: null,
          bc: null
        },
        queryParamsHandling: 'merge',
      });
    }
    this.subscriptionService.clearAllPreloadNotification();
  }

  ngOnInit() {
    const isLoggedIn = !!localStorage.getItem(AUTH_TOKEN_KEY);
    if (isLoggedIn) {
      this.userService.loadUserInstance();
    }
    if (isLoggedIn && this.userService && this.userService.currentUser && this.userService.currentUser.access_token) {
      this.userIdleService.setUserLoggedIn(true);
      if (this.userService.isRightClickDisable()) {
        this.loadScript();
      }

    }

    this.subscriptions.add(
      this.userService.isSideNavHiddenObs
        .pipe(delay(0))
        .subscribe((isSideNavHidden) => (this.isSideNavHidden = isSideNavHidden))
    );

    this.subscriptions.add(
      this.userService.isHeaderImageHiddenObs
        .pipe(delay(0))
        .subscribe((isHeaderImageHidden) => (this.isHeaderImageHidden = isHeaderImageHidden))
    );

    this.subscriptions.add(
      this.userService.isSettingButtonHiddenObs
        .subscribe((isSettingButtonHidden) => (this.isSettingButtonHidden = isSettingButtonHidden))
    );

    this.subscriptions.add(
      this.userService.pushNotificationObs.subscribe((pushNotificationArray) => {
        this.pushNotificationArray = [];
        this.pushNotificationArray = [...pushNotificationArray];
      })
    )

    this.subscriptions.add(
      this.userService.countUnreadNotificationObs.subscribe((count) => {
        this.unReadNotificationCount = 0;
        this.unReadNotificationCount = count;
      })
    )

    this.subscriptions.add(
      this.userService.switchCompanyObs.subscribe((switchCompanyArray) => {
        this.switchCompanyArray = [];
        this.switchCompanyArray = [...switchCompanyArray];
        this.switchCompanySelected = this.switchCompanyArray.length > 1 ? this.selectByDefaultSwitchCompany() : null;
      })
    )

    this.subscriptions.add(
      this.userService.userRolesObs.subscribe((UserRolesArray) => {
        this.UserRolesArray = [];
        this.UserRolesArray = [...UserRolesArray];
        this.userRoleSelected = this.UserRolesArray.length > 1 ? this.selectByDefaultRoles() : null;
      })
    )

    this.subscriptions.add(
      this.userService.loadCompanyLogoObs
        .subscribe((value) => {
          this.callingCompanyDetails = value
        })
    );

    this.subscriptions.add(
      this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationStart) {
          const { scrollTop } = this.contentDiv.nativeElement;
          const { state } = this.router.getCurrentNavigation().extras;

          if (state && state.preserveState) {
            this.pageService.setPageScrollState({ scrollTop });
          }
          if (state && state.readFromState) {
            this.pageService.readFromState = state.readFromState;
          } else {
            this.pageService.readFromState = false;
          }
        }

        if (evt instanceof NavigationEnd) {
          this.sideNavService.pageNavigateEndSubject.next(evt);
        }
      })
    );

    this.subscriptions.add(
      this.sideNavService.getOpenedState().subscribe((sideNavState) => {
        this.sideNavOpened = sideNavState;
      })
    );

    if (this.userService.currentUser) {
      this.productGuideService.setCurrentStatusOfProductGuideHistory(this.localStorageService.getItem(LOCAL_STORAGE_KEYS.USER_GUIDE))
    }
  }

  loadScript() {
    if ((<any>window).preventRightClick) {
      ((<any>window).preventRightClick());
    }
  }

  selectByDefaultRoles() {
    const userRole = (this.userService.currentUser && this.userService.currentUser.userRole) ? this.userService.currentUser.userRole : null;
    return this.UserRolesArray.find(ele => ele === userRole);
  }


  isPublicPage() {
    return (
      _.isEqual(this.location.path(), '') ||
      _.startsWith(this.location.path(), '/home') ||
      this.isSignupPage() ||
      _.startsWith(this.location.path(), 'unsubscribe') ||
      _.startsWith(this.location.path(), 'enroll-whatsapp') ||
      _.startsWith(this.location.path(), '/pay-invoice') ||
      _.startsWith(this.location.path(), '/getstarted') ||
      _.startsWith(this.location.path(), '/otp-login') ||
      _.startsWith(this.location.path(), '/card-statement-pay') ||
      _.startsWith(this.location.path(), '/payment-request-pay') ||
      _.startsWith(this.location.path(), '/activateCard') ||
      _.startsWith(this.location.path(), '/voucher-details') ||
      _.startsWith(this.location.path(), '/forbidden') ||
      !(this.userService.currentUser && this.userService.currentUser.userRole)
    );
  }

  selectByDefaultSwitchCompany() {
    const companyId = (this.userService.currentUser && this.userService.currentUser.companyId) ? this.userService.currentUser.companyId : this.userService.isEnkashUser() ? 'ENKASH' : null;
    return this.switchCompanyArray.find(ele => ele.companyId === companyId);
  }

  isAccountTncPending(): boolean {
    return this.userService.isAccountTnCPending() && this.userService.currentUser.userRole !== 'EMPLOYEE';
  }

  isSignupPage() {
    const path = this.location.path();
    return _.startsWith(path, '/signup');
  }

  /** Merges route data from the full activated route path (handles lazy-loaded and nested routes). */
  private getRouteDataFromTree(): RouteDataModel {
    let merged: RouteDataModel = {};
    let r: ActivatedRoute | null = this.router.routerState.root;
    while (r) {
      if (r.snapshot?.data) {
        merged = { ...merged, ...r.snapshot.data };
      }
      r = r.firstChild;
    }
    return merged;
  }

  /** Hide toolbar only on /login when using new PIN flow. All other pages use original condition. */
  get showEnkashToolbar(): boolean {
    const url = this.router.url;
    const isOnOldLogin = url.startsWith('/login/old-login');
    const isOnLogin = !isOnOldLogin && url.startsWith('/login');
    if (isOnLogin && environment.usePinLogin) {
      return false;
    }
    if (isOnLogin && !environment.usePinLogin) {
      return true;
    }
    if (isOnOldLogin) {
      return true;
    }
    return this.isSettingButtonHidden || this.sidebarEnabled || this.isHeaderImageHidden;
  }

  get isSdebarAllowed(): boolean {
    const sidebarEnabled = !this.routeData.hideHeaderFooter && !this.isSideNavHidden && !this.isPublicPage();
    if (this.sidebarEnabled !== sidebarEnabled) {
      this.sideNavService.changeCurrentSidebar({ iconVisibility: sidebarEnabled, sidebarVisible: false });
    }
    this.sidebarEnabled = sidebarEnabled;
    return sidebarEnabled
  }

  bruu() {
    this.pageService.triggerScrollEvent();
  }

  scrollToTop(argEvent: any) {
    const component = argEvent.constructor.name;
    if (component === 'TncOnLoginComponent' || component === 'ChangeNewPasswordComponent') {
      this.contentDiv.nativeElement.scrollTop = 0;
      const { scrollTop } = this.contentDiv.nativeElement;
      this.pageService.setPageScrollState({ scrollTop });
      if (component === 'TncOnLoginComponent') {
        this.subscriptions.add(
          argEvent.isCardTnCActive.subscribe((res) => {
            if (res) {
              this.contentDiv.nativeElement.scrollTop = 0;
              const { scrollTop } = this.contentDiv.nativeElement;
              setTimeout(() => {
                this.pageService.setPageScrollState({ scrollTop });
              }, 1000);
            }
          })
        );
      }
    } else {
      if (this.contentDiv) {
        (this.contentDiv.nativeElement as HTMLElement).scrollTop = 0;
      }
    }
  }
  openSnackBar(message: string, type) {
    this.toasterService.showToaster(message, type);
  }

  onChangingAccount(account: UserCompanyModel) {
    const onVerifyEmitter: EventEmitter<any> = new EventEmitter();
    const dismissModal: EventEmitter<any> = new EventEmitter();
    const mobileNumber = account.mobile;
    if (!!account.redirectionUrl) {
      window.location.href = account.redirectionUrl;
    } else {
      this.confirmationModal
        .showInformationalModal(OtpModalComponent, {
          centered: true,
          scrollable: true,
          mobile: mobileNumber,
          companyId: account.companyId,
          onVerify: onVerifyEmitter,
          dismissModal
        })
        .then((item: RequestState) => {
        })
        .catch((err) => {
          console.log(err);
        });

      onVerifyEmitter.subscribe((item: { submitRequestState: RequestState, otpValue: number }) => {
        item.submitRequestState.pending();
        const ajax$ = this.userService
          .loginForMultipleAccounts(`username=${mobileNumber}&companyId=${account.companyId}&grant_type=password&otp=${item.otpValue}`);

        ajax$.pipe(
          switchMap(element => {
            return this.userService.getNudgeDetails();
          })
        ).subscribe(
          (res) => {
            this.isSwitchCompany = true;
            item.submitRequestState.completed();
            dismissModal.emit();
            const route = this.userService.decideLandingPageForUser(this.userService.currentUser, 'OTP', false, false, res.payload.data);
            if (route[0] !== '/home') {
              this.router.navigate(route);
            } else if (window.location.pathname.includes('home')) {
              window.location.reload();
            } else {
              this.router.navigate(['home']);
            }

            this.menuOptionsService.initMenuOptions();
          },
          ({ error }) => {
            item.submitRequestState.completed();

            if (error && error['error_description']) {
              this.openSnackBar(
                error['error_description'],
                ToasterType.ERROR
              );
              return;
            }
            this.openSnackBar(
              'Something Went Wrong',
              ToasterType.ERROR
            );

          }
        );
        // submitRequestState.pending();
      });
    }
  }

  isAxisBBPSuser() {
    return this.userService.isAxisBBPSuser();
  }

  isCobrandedTncRoute(): boolean {
    const url = this.router.url;
    const isPinLoginRoute = url.startsWith('/login') && !url.startsWith('/login/old-login') && environment.usePinLogin;
    return url.includes('partner/tnc') || url.includes('card/view') || isPinLoginRoute;
  }


  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  onChangingRole(role): void {

    const ajax$ = this.userService.loginForMultipleRole(role);

    ajax$.pipe(
      switchMap(element => {
        return this.userService.getNudgeDetails();
      })
    ).subscribe(
      (res) => {
        if (res) {
          this.router.navigate(['/home'])
          window.location.reload();
        }
        this.menuOptionsService.initMenuOptions();
      },
      ({ error }) => {
        if (error && error['error_description']) {
          this.openSnackBar(
            error['error_description'],
            ToasterType.ERROR
          );
          return;
        }
        this.openSnackBar(
          'Something Went Wrong',
          ToasterType.ERROR
        );

      }
    );
  }
}
